<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<wr-sidenav [treeData]="TREE_DATA" [selectedNode]="selectedNode" (updateNavigation)="handleUpdateNavigation($event)">
  <router-outlet></router-outlet>
</wr-sidenav>
<div class="version-link">
  <span>Gallery 2.1.0</span>
</div>
